import {Component, effect, OnDestroy, OnInit, signal} from '@angular/core';
import {AppointmentRibbonService} from "@app/areas/appointments/services/appointment-ribbon.service";

import {AppointmentParticipant} from "@app/areas/appointments/models/appointment-participant.interface";
import {AppAuthService} from "@services/core/auth/app-auth.service";
import {LocalizedDatePipe} from "@shared/pipes/localized-date/localized-date.pipe";
import {IconPath} from "@shared/common/icons";
import {IconComponent} from "@shared/components/icon/icon.component";
import {AppointmentDetail} from "@app/areas/appointments/models/appointment.interface";
import { ModalService } from '@src/app/shared/services/helpers/modal/modal.service';
import {
  AppointmentCallModalComponent
} from "@app/areas/appointments/components/appointment-call-modal/appointment-call-modal.component";
import { AppointmentType } from '../../models/appointment-type.enum';
import {TooltipDirective} from "ngx-bootstrap/tooltip";
import {take, takeUntil} from "rxjs/operators";
import { Subject } from 'rxjs';
import {hasValue} from "@shared/utils/helpers";

@Component({
  selector: 'app-appointment-ribbon',
  imports: [
    LocalizedDatePipe,
    IconComponent,
    TooltipDirective
],
  templateUrl: './appointment-ribbon.component.html',
  styleUrl: './appointment-ribbon.component.scss',
  standalone: true
})
export class AppointmentRibbonComponent implements OnInit {
  hasAppointments = false;
  authUserId = null;

  isMinimised$ = signal<boolean>(false)
  modalIsOpen$ = false;

  AppointmentType = AppointmentType

  constructor(
    public modalService: ModalService,
    public service: AppointmentRibbonService,
    private auth: AppAuthService
  ) {
    effect(() => {
      const u = this.auth.user$();
      if (hasValue(u)) {
        this.authUserId = u.identityProfile.id
      }
    })

    effect(() => {
      this.hasAppointments = this.service.appts$().length > 0;
    })
  }

  ngOnInit(): void {
    this.service.refresh()
  }

  joinAppointment(appt: AppointmentDetail): void {
    if (this.modalIsOpen$) {
      return
    }

    this.modalIsOpen$ = true;
    this.modalService.open(AppointmentCallModalComponent, { appointmentId: appt.appointment.id })

    this.modalService.onClose
      .pipe(take(1))
      .subscribe(_ => this.modalIsOpen$ = false)
  }

  getAppointmentTypeIcon(apptType: AppointmentType): IconPath {
    switch (apptType) {
      case AppointmentType.Audio:
        return 'mdi-phone'
      case AppointmentType.InPerson:
        return 'mdi-account-outline'
      case AppointmentType.Video:
        return 'mdi-video'
      default:
        return null;
    }
  }

  getInitials(p: AppointmentParticipant): string {
    const first = p.firstName?.trim()  || '';
    const last  = p.lastName?.trim()   || '';

    // both names present → first letter of each
    if (first && last) {
      return `${first[0]}${last[0]}`.toUpperCase();
    }

    // only first name → first two letters
    if (first) {
      return first.slice(0, 2).toUpperCase();
    }

    // only last name → first two letters
    if (last) {
      return last.slice(0, 2).toUpperCase();
    }

    // no name given
    return '';
  }
}
